





















































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import moment from "moment";

import {
  ExpenseCategory,
  ExpenseEligibilityGroup,
} from "@/shared/types";

import EditExpenseForm from "@/shared/components/expenseV2/EditExpenseForm.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import { expenseCategoryIcon } from "@/shared/awesomeIconMapper";
@Component({
  components: {
    CurrencyAmount,
    EditExpenseForm
  }
})
export default class ReimbursedExpenseChildRow extends Vue {
  expenseCategoryIcon = expenseCategoryIcon;
  @Prop()
  expense: any; // PossibleExpense

  @Prop()
  undocumentedExpense: boolean;

  @Prop()
  onSubmit: () => void;

  isToggled: boolean;
  ExpenseEligibilityGroup = ExpenseEligibilityGroup;

  isOpen = false;

  get expenseCategory (): ExpenseCategory {
    return this.expense.expenseCategory;
  }

  get title (): string {
    return this.expense.name;
  }

  get numberOfAttachments (): number {
    if (this.expense && this.expense.attachmentNames) {
      return this.expense.attachmentNames.length;
    }

    return 0;
  }

  toggleEdit (e): void {
    e.preventDefault();
    if (this.undocumentedExpense) {
      return;
    }
    this.isOpen = !this.isOpen;
  }

  onEditClose (): void {
    this.isOpen = false;
    if (this.onSubmit) {
      this.onSubmit();
    }
  }

  get displayEditForm (): boolean {
    return this.isOpen && !this.undocumentedExpense;
  }

  get formattedDate (): string {
    return moment(this.expense.dateOfService).format("MMM DD");
  }

  get absoluteEligibleAmount (): number {
    const amount = this.expense.reimbursedAmount;
    return Math.abs(amount);
  }
}
